<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Ingreso de Anexos Manuales
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12">
                        <modalComponent :objetoModal="objetoModal" :listParametros="listParametros" :active="objetoModal.abrirModal"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal" :return-value.sync="objSearch.fechaDesde" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaDesde" label="Fecha Desde *" prepend-inner-icon="event" readonly outlined dense v-on="on"/>
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaDesde" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.desde.abrirModal = false" v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.dialogFechaDesde.save(objSearch.fechaDesde);" v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal" :return-value.sync="objSearch.fechaHasta" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaHasta" label="Fecha Hasta *" prepend-inner-icon="event" readonly outlined dense v-on="on"/>
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaHasta" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.hasta.abrirModal = false" v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.dialogFechaHasta.save(objSearch.fechaHasta);" v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Canal *" color="textbox" v-model="objSearch.idCanal"
                            :items="listGeneral.listCanal" item-value="idCanal" item-text="canal" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="objSearch.idAseguradora"
                            @change="onListarSeguro" :items="listGeneral.listAseguradora" item-value="idAseguradora"
                            item-text="aseguradora" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="objSearch.idSeguro"
                            :items="listGeneral.listSeguro" item-text="seguro" item-value="idSeguro"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Póliza *" color="textbox" v-model="objSearch.idPoliza" @change="onListarCertificado"
                            :items="_.filter(_.get(listGeneral,'listPoliza',[]),(v) => { return parseInt(v.idSeguro) == parseInt(objSearch.idSeguro) })" 
                            item-value="idPoliza" item-text="poliza" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Certificado *" color="textbox" v-model="objSearch.idCertificado"
                            @change="onListarSolicitud" :items="listGeneral.listCertificado" item-value="idCertificado"
                            item-text="certificado" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objSearch.idEstado"
                            :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado" @change="onListarSolicitud"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-tooltip top color="primary">
                            <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="primary" @click="onListarSolicitud" v-on="on"
                                        :disabled="disabled">
                                        <v-icon dark>search</v-icon>
                                    </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearch.search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objSearch.search" :headers="listGeneral.cabecera" :items="listGeneral.detalle"
                            class="elevation-3">
                            
                            <template v-slot:item.accion="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="edit(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>                                
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="objSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        components: {
            modalComponent: () => import('@/components/ajustePoliza/IngresoDocumentoManualComponent.vue')
        },
        name:'IngresoDocumentoManualView',
        data: () => ({
            
                listGeneral: {},
                listParametros: {},
                objDate:{
                    desde:{ abrirModal:false },
                    hasta:{ abrirModal:false }
                },
                objetoModal:{abrirModal:false, titulo: ''},
                objSearch: {
                    opcion: 'LISTAR_SOLICITUD',
                    search: '',
                    idTipoPoliza:null,
                    fechaDesde: moment().format('YYYY-MM-DD'),
                    fechaHasta: moment().format('YYYY-MM-DD'),
                    idCanal: null,
                    idAseguradora: null,
                    idSeguro: null,
                    idPoliza: null,
                    idCertificado: null,
                    idEstado: null
                }
        }),
        created(){
            this.onCargaGeneral();
        },
        computed:{
            disabled(){
                return !_.isUndefined(this.objSearch.idPoliza) && !_.isNull(this.objSearch.idPoliza) ? false : true;
            }
        },
        methods: {
            apiSend(ruta,objeto){
                return axios.post(`${BASE_URI}${ruta}`,objeto);
            },
            onCargaGeneral(){
                axios.post(`${BASE_URI}administrador/ingreso-documento-manual/cargaGeneral`,{})
                    .then((r) =>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0 ) throw mensajeEstandar.errorPeticion;
                            this.listGeneral        = r.data.data.listas;
                            this.listParametros     = r.data.data.parametros;
                            this.objSearch.idEstado = _.toString(this.listParametros.idEstadoDefault);
                            
                            this.objSearch.idCanal       = this.listGeneral.listCanal[0].idCanal;
                            this.objSearch.idAseguradora = this.listGeneral.listAseguradora[0].idAseguradora;
                            this.objSearch.idEstado      = _.toString(this.listParametros.idEstadoDefault);    
                            this.objSearch.idTipoPoliza  = _.toString(this.listParametros.id_tipo_poliza_maestra);    
                            
                            return this.onListarSeguro('L');
                    })
                    .catch((e)=>{  
                        mensajesAlerta(e,'E');
                    });
            },
            onListarSeguro(event){
                if(!_.isUndefined(event)){
                    this.$set(this.listGeneral,'listSeguro',[]);
                    this.$set(this.listGeneral,'listPoliza',[]);
                    this.$set(this.listGeneral,'detalle',[]);
                    this.objSearch.idSeguro = undefined;

                    this.apiSend('administrador/poliza/listar',_.merge({},{opcion:'L_SEGURO_X_ASEGURADORA'},_.pick(this.objSearch,['idAseguradora','idTipoPoliza','idEstado'])))
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                this.$set(this.listGeneral,'listSeguro',r.data.data);
                                this.$set(this.listGeneral,'listPoliza',r.data.data);
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,'E')
                        });
                }
            },
            onListarCertificado(event){
                if(!_.isUndefined(event)){
                    this.$set(this.listGeneral,'listCertificado',[]);
                    this.$set(this.listGeneral,'detalle',[]);
                    this.objSearch.idCertificado = undefined;

                    this.apiSend('administrador/certificado/listar',_.merge({},{opcion:'LISTAR_POL_CER'},_.pick(this.objSearch,['idPoliza','idEstado'])))
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                this.$set(this.listGeneral,'listCertificado',r.data.data);
                                return this.onListarSolicitud('L');
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,'E')
                        });
                }
            },   
            onListarSolicitud(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    this.$set(this.listGeneral,'detalle',[]);
                    var keys = ['idPoliza','idEstado','idCertificado','fechaDesde','fechaHasta'];

                    return  this.apiSend('administrador/ingreso-documento-manual/listar',_.merge({},{opcion:'LISTAR'},_.pick(this.objSearch,keys)))
                                .then((r)=>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                        var l =  _.chain(_.cloneDeep(r.data.data))
                                                        .groupBy('index')
                                                        .mapValues(_.partial(_.map, _, 'descripcion'))
                                                        .value();

                                        this.$set(this.listGeneral,'detalle',_.map(r.data.data,(v) =>{
                                                                                                        var ll = _.filter(l,(vv,k)=>{ return parseInt(k) == parseInt(v.index); });
                                                                                                        v.descripcion = _.join(_.get(ll,'0'),'*');
                                                                                                        v.idSolicitud = v.index;
                                                                                                        return v;
                                                                                                    })
                                                );
                                    return r;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e,error);
                                    return e;
                                });
                }
            },
            edit(objeto) {
                this.objetoModal = _.merge({},this.objetoModal,objeto,{abrirModal:true});
            },
            reset(){
                this.objetoModal = {abrirModal:false,titulo:''};
            },
            insertarActualizar(objeto){                
                return axios.post(`${BASE_URI}administrador/ingreso-documento-manual/insertOrUpdate`, objeto)
                            .then((r) =>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    mensajeAlertaTiempo(_.get(r,['data','mensaje'],'Registro efectuado con éxito.'),'S');
                                    return this.onListarSolicitud('L');
                            })
                            .then((r) =>{
                                return true;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,'E');
                                return false;
                            });
            },
        },
        provide() {
            return {
                insertarActualizar : this.insertarActualizar,
                reset              : this.reset
            }
        }
    }
</script>